/* @flow */
import Faq from 'entities/Faq';
import Collection from 'lib/Collection';

export default class Faqs extends Collection<Faq> {
  initialize() {
    this.model = Faq;
  }

  parse(response: Object) {
    return response.map(article => Faq.fromJSON(article));
  }

  // $FlowFixMe
  static fetch(query: string, locale = 'en-US'): Promise<Faqs> {
    return Faq.searchFaqs(query, locale).then(response => this.fromJSON(response));
  }
}
